export default "__VITE_ASSET__assyy1qm__"